export default __webpack_public_path__ + "static/media/C5.60c43efe.svg";